/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewSourceCodeFileMetadata } from '../models/new-source-code-file-metadata';
import { SourceCodeFileMetadata } from '../models/source-code-file-metadata';
import { SourceCodeFileMetadataPartial } from '../models/source-code-file-metadata-partial';
import { SourceCodeFileMetadataWithRelations } from '../models/source-code-file-metadata-with-relations';

@Injectable({
  providedIn: 'root',
})
export class SourceCodeFileMetadataControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation sourceCodeFileMetadataControllerFindById
   */
  static readonly SourceCodeFileMetadataControllerFindByIdPath = '/source-code-file-metadata/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<SourceCodeFileMetadataWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeFileMetadataControllerService.SourceCodeFileMetadataControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SourceCodeFileMetadataWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<SourceCodeFileMetadataWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<SourceCodeFileMetadataWithRelations>) => r.body as SourceCodeFileMetadataWithRelations)
    );
  }

  /**
   * Path part for operation sourceCodeFileMetadataControllerDeleteById
   */
  static readonly SourceCodeFileMetadataControllerDeleteByIdPath = '/source-code-file-metadata/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeFileMetadataControllerService.SourceCodeFileMetadataControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation sourceCodeFileMetadataControllerUpdateById
   */
  static readonly SourceCodeFileMetadataControllerUpdateByIdPath = '/source-code-file-metadata/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: SourceCodeFileMetadataPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeFileMetadataControllerService.SourceCodeFileMetadataControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: SourceCodeFileMetadataPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation sourceCodeFileMetadataControllerFind
   */
  static readonly SourceCodeFileMetadataControllerFindPath = '/source-code-file-metadata';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<SourceCodeFileMetadataWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeFileMetadataControllerService.SourceCodeFileMetadataControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SourceCodeFileMetadataWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<SourceCodeFileMetadataWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SourceCodeFileMetadataWithRelations>>) => r.body as Array<SourceCodeFileMetadataWithRelations>)
    );
  }

  /**
   * Path part for operation sourceCodeFileMetadataControllerCreate
   */
  static readonly SourceCodeFileMetadataControllerCreatePath = '/source-code-file-metadata';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewSourceCodeFileMetadata
  }): Observable<StrictHttpResponse<SourceCodeFileMetadata>> {

    const rb = new RequestBuilder(this.rootUrl, SourceCodeFileMetadataControllerService.SourceCodeFileMetadataControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SourceCodeFileMetadata>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewSourceCodeFileMetadata
  }): Observable<SourceCodeFileMetadata> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<SourceCodeFileMetadata>) => r.body as SourceCodeFileMetadata)
    );
  }

}
